import {
    instance
} from '../../util/http'
import apis from '../../config/apis'

const get = () => {
    return instance.get(apis.User.like)
}
export default {
    get
}